/* src/app/core/pages/error-fourohfour/error-fourohfour.component.scss */
/*# sourceMappingURL=error-fourohfour.component.css.map */
